/**
 * Card registry for declarative related-entity sections: maps a string key
 * (referenced by section configs, keeping them serializable) to its card
 * renderer. Kept separate from `entityCards.tsx` so that file only exports
 * components (React Fast Refresh requirement).
 */

import type { ComponentType } from 'react';

import type { EntityCardProps } from './entityCards';
import {
  MeetingCard,
  MeetingDetailCard,
  MeetingNotesCard,
  RiskCard,
} from './entityCards';

/** String keys used by section configs to reference a card renderer. */
export type EntityCardKey =
  | 'meetingCard'
  | 'meetingDetailCard'
  | 'meetingNotesCard'
  | 'riskCard';

/** Registry mapping a card key to its renderer. */
export const ENTITY_CARDS: Record<
  EntityCardKey,
  ComponentType<EntityCardProps>
> = {
  meetingCard: MeetingCard,
  meetingDetailCard: MeetingDetailCard,
  meetingNotesCard: MeetingNotesCard,
  riskCard: RiskCard,
};
